import { useState } from "react";
import { Form } from "react-bootstrap";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import CustomDropdown from "../../components/shared/dropdown/CustomDropdown";
import Button from "../../components/shared/buttons/button";
import { useCreateRedemptionCodeMutation } from "../../app/redemptionApi/redemptionApi";
import { showToast } from "../../helpers/Utils";

const PRODUCT_OPTIONS = [{ value: "captify_premium", label: "Captify Premium" }];

const PERIOD_OPTIONS = [
  { value: "1", label: "1 months" },
  { value: "3", label: "3 months" },
  { value: "6", label: "6 months" },
  { value: "12", label: "12 months" },
  { value: "24", label: "24 months" },
  { value: "36", label: "36 months" },
];

const emptyForm = {
  product: "captify_premium",
  durationMonths: "1",
  linkToOrder: false,
  orderId: "",
};

export default function AddRedemptionCodeModal({ show, setShow, onSuccess }) {
  const [form, setForm] = useState(emptyForm);
  const [createCode, { isLoading }] = useCreateRedemptionCodeMutation();

  const update = (patch) => setForm((prev) => ({ ...prev, ...patch }));

  const handleClose = () => {
    if (isLoading) return;
    setForm(emptyForm);
    setShow(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.linkToOrder && !form.orderId.trim()) {
      showToast("Enter an order ID to link", "error");
      return;
    }

    const orderValue = form.orderId.trim();
    const payload = {
      durationMonths: Number(form.durationMonths),
    };
    if (form.linkToOrder && orderValue) {
      payload.shopifyOrderName = orderValue.startsWith("#")
        ? orderValue
        : `#${orderValue}`;
      payload.shopifyOrderId = orderValue.replace(/^#/, "");
    }

    try {
      const result = await createCode(payload).unwrap();
      const createdCode = result?.data?.code?.code;
      setForm(emptyForm);
      setShow(false);
      onSuccess?.(createdCode);
    } catch (err) {
      showToast(err?.data?.message || "Failed to create redemption code", "error");
    }
  };

  return (
    <CommonModal
      show={show}
      setShow={(next) => {
        if (next === false) handleClose();
      }}
      title="Add New Code"
      className="redemption-add-modal"
      centered
    >
      <Form onSubmit={handleSubmit} className="redemption-add-form">
        <Form.Group className="mb-3">
          <Form.Label className="cmn_label">Product</Form.Label>
          <CustomDropdown
            label="Product"
            options={PRODUCT_OPTIONS}
            value={form.product}
            onSelect={(opt) => update({ product: opt.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="cmn_label">Period</Form.Label>
          <CustomDropdown
            label="Period"
            options={PERIOD_OPTIONS}
            value={form.durationMonths}
            onSelect={(opt) => update({ durationMonths: opt.value })}
          />
        </Form.Group>

        <Form.Check
          className="redemption-add-check mb-3"
          type="checkbox"
          id="redemption-link-to-order"
          label="Link to Order"
          checked={form.linkToOrder}
          onChange={(e) =>
            update({
              linkToOrder: e.target.checked,
              orderId: e.target.checked ? form.orderId : "",
            })
          }
        />
        {form.linkToOrder && (
          <Form.Control
            className="cmn_input mb-3"
            type="text"
            placeholder="Shopify order ID"
            value={form.orderId}
            onChange={(e) => update({ orderId: e.target.value })}
          />
        )}

        <div className="d-flex align-items-center gap-2 mt-4">
          <Button
            type="submit"
            label="Add"
            loading={isLoading}
            disabled={isLoading}
          />
          <Button
            type="button"
            label="Cancel"
            className="grey-btn"
            disabled={isLoading}
            onClick={handleClose}
          />
        </div>
      </Form>
    </CommonModal>
  );
}
